import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import DocumentPackageCard from './DocumentPackageCard';

const formatDetailLine = (parts) => parts.filter(Boolean).join(' · ');

const StayListingCard = ({ listing, onView, viewOnProviderLabel, bookNowLabel }) => {
  const { t } = useTranslation();
  const listingUrl = listing.url || listing.booking_url;
  const isRental = listing.type === 'rental';
  const typeLabel = isRental ? t('stays.typeRental') : t('stays.typeHotel');
  const ratingScale = listing.ratingScale || (listing.type === 'hotel' ? 10 : 5);

  const handleOpen = () => {
    if (listingUrl) {
      window.open(listingUrl, '_blank', 'noopener,noreferrer');
    }
    if (onView) {
      onView(listing);
    }
  };

  const bedroomLabel = listing.bedrooms
    ? t('stays.bedroomsCount', { count: listing.bedrooms })
    : null;
  const bathroomLabel = listing.bathrooms
    ? t('stays.bathroomsCount', { count: listing.bathrooms })
    : null;
  const sleepsLabel = listing.sleeps
    ? t('stays.sleepsCount', { count: listing.sleeps })
    : null;
  const detailLine = formatDetailLine([bedroomLabel, bathroomLabel, sleepsLabel]);
  const subtitleLine = formatDetailLine([
    listing.propertyType,
    listing.neighborhood || listing.location,
  ]);
  const rows = [
    !listing.isDeepLink && listing.rating != null
      ? {
          label: t('packagesPage.rating'),
          value: t('stays.ratingOutOf', { rating: listing.rating, scale: ratingScale }),
          extra: listing.reviewsCount != null ? t('stays.reviewsCount', { count: listing.reviewsCount }) : null,
        }
      : null,
    listing.distanceFromCenter
      ? { label: t('packagesPage.distance'), value: listing.distanceFromCenter }
      : null,
    listing.isDeepLink
      ? { label: t('packagesPage.price'), value: viewOnProviderLabel }
      : {
          label: t('packagesPage.price'),
          value: listing.price || t('stays.seePrice'),
          extra: listing.priceLabel || null,
        },
  ].filter(Boolean);

  return (
    <Grid item xs={12} sm={6} md={4}>
      <DocumentPackageCard
        testId={`stay-listing-card-${listing.id}`}
        imageUrl={listing.image || 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&h=400&fit=crop&q=80'}
        imageAlt={listing.name}
        badges={[typeLabel]}
        eyebrow={listing.propertyType || listing.neighborhood || listing.location || typeLabel}
        title={listing.name}
        location={subtitleLine}
        description={formatDetailLine([detailLine, listing.amenities?.slice(0, 3).join(' · ')])}
        rows={rows}
        actionLabel={listing.isDeepLink ? viewOnProviderLabel : bookNowLabel}
        onClick={listingUrl || onView ? handleOpen : undefined}
      />
    </Grid>
  );
};

export default StayListingCard;
